import styled, {css} from 'styled-components';

interface ItemProps {
  fSize?: string;
  padding?: string;
  fullWidth?: boolean;

  readonly lColor?: string;
  readonly rColor?: string;
  readonly fColor?: string;
  readonly bColor?: string;
  readonly aColor?: string;
  readonly lMargin?: string;
  readonly rMargin?: string;
  readonly xMargin?: string;
  readonly boradius?: string;
  readonly disabled?: boolean;
  readonly responsive?: string;
  readonly colorDisabled?: string;
  readonly fWeight?: string;
}

export const ButtonContainer = styled.button<ItemProps>`
  font-family: 'Proxima Nova';
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 45px;
  padding: 0;
  border-radius: ${props => props?.boradius && props?.boradius};
  
  ${props => `border: 1px solid ${props.bColor};`}
  ${props => `margin: ${props.xMargin};`}

  &:focus,
  &:active {
    ${props => `border: 1px solid ${props.bColor};`}
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: ${props => props.colorDisabled ? '1' : '0.3'};
  }
`;

export const ButtonIcon = styled.span<ItemProps>`  
  border-bottom-left-radius: 4px;
  color: var(--BackgroundColor);
  border-top-left-radius: 4px;
  display: inline-flex;
  align-items: center;
  height: 100%;


  &:active {
    ${props => (props.aColor ? `background-color: ${props.aColor};` : '')}
  }

  ${props => {
    let lColor = '';
    const lMargin = `padding: ${props.lMargin};`;
    if (props.lColor) {
      lColor = `background-color: ${props.lColor};`;
    } else {
      lColor = `background-color: var(--SecondaryBlue);`;
    }

    return css`
       {
        ${lColor}
        ${lMargin}
      }
    `;
  }}

  ${props => {
    if (props.responsive) {
      return css`
        @media (max-width: ${props.responsive}) {
          border-bottom-right-radius: 4px;
          border-top-right-radius: 4px;
          padding: 0 12px;
        }
      `;
    } else {
      return '';
    }
  }}
`;

export const ButtonSpan = styled.span<ItemProps>`
  font-family: 'Proxima Nova';
  font-size: ${props => props.fSize || "inherit"};
  border-bottom-right-radius: 4px;
  color: var(--BackgroundColor);
  border-top-right-radius: 4px;
  border-radius: ${props => props?.boradius && props?.boradius};
  display: inline-flex;
  align-items: center;
  width: ${props => (props.fullWidth ? '100%' : 'max-content')};
  font-weight: ${props => (props.fWeight ? props.fWeight : '600')};
  height: 100%;
  justify-content: center;

  &:active {
    ${props => (props.aColor ? `background-color: ${props.aColor};` : '')}
  }

  ${props => {
    let rColor = '';
    let cursor = `cursor:pointer`;
    const rMargin = `padding: ${props.rMargin};`;
    const fColor = `color: ${props.fColor};`;

    if (props.disabled && props.colorDisabled) {
      rColor = `background: ${props.colorDisabled};`;
    } else if (props.rColor) {
      rColor = `background: ${props.rColor};`;
    } else {
      rColor = `background-color: var(--PrimaryBlue);`;
    }
    if (props.rColor === '#ACB1C0') {
      cursor = `cursor:default`;
    }

    return css`
       {
        ${rColor}
        ${fColor}
        ${rMargin}
        ${cursor}
      }
    `;
  }}

  ${props => {
    if (props.responsive) {
      return css`
        @media (max-width: ${props.responsive}) {
          display: none !important;
        }
      `;
    } else {
      return '';
    }
  }}
`;
